import { render, staticRenderFns } from "./VCardBsp.vue?vue&type=template&id=44e1d66d&scoped=true"
import script from "./VCardBsp.vue?vue&type=script&lang=ts"
export * from "./VCardBsp.vue?vue&type=script&lang=ts"
import style0 from "./VCardBsp.vue?vue&type=style&index=0&id=44e1d66d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e1d66d",
  null
  
)

export default component.exports